import { environment } from "../../environments/environment.prod";

/****************************************************************************************************************
* ©2019 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/
export class Constants {
  public static API_SUP_URL = `${environment.baseContext}/supapi/`;
  public static API_COMMON_URL = `${environment.baseContext}/commonapi`;
  public static API_COMMON_COMMON_URL = `${environment.baseContext}/commapi/`;
  public static API_COLLABORATION_URL = `${environment.baseContext}/collaborationapi`;
  public static SURVEY_BASE_URL = "/supplierSurvey";
  public static BUYER_URL = '/buyer';

  public static CATALOG_BASE_URL = 'catalog/';
  public static REF_CODE_BASE_URL = '/referenceCode/';
  public static CURRENCY_BASE_URL = '/currency/';
  public static PUNCHOUT_BASE_URL = 'punchout/';
  public static REFERENCEDATA_BASE_URL = '/referenceData';

  public static EMAIL_REGEX = '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$';
  public static PHONE_NUMBER_REGEX = '^([0-9-\+]){10,15}$';
  public static PINCODE_REGEX = '^([0-9]){4,6}$';
  public static LANGUAGE = 'en_us';
  public static NAME_MAX_LENGTH = 50;
  public static SUPP_NAME_MAX_LENGTH = 200;
  public static ADR_MAX_LENGTH = 200;
  public static TEXT_REGEX = '^[0-9a-zA-Z ]*$';
  public static CAT_NAME_MAX_LENGTH = 250;
  public static CAT_DESC_MAX_LENGTH = 1000;
  public static DUNS_REGEX = '^([0-9]){3,9}$';

  public static NUMBER_REGEX = '^[0-9]*$';
  public static DECIMAL_REGEX = '^[0-9]{1,10}(\\.[0-9]{1,2})?$';
  public static MAX_FILE_SIZE = 10485760;
  public static ALLOWED_FILE_EXTNS = ['xlsx', 'json', 'pdf', 'png', 'jpg', 'avi', 'mp4', 'ppt', 'pptx', 'xls', 'xlsx', 'doc', 'docx', 'pdf', 'avi', 'wmv', 'flv', 'mpeg', 'mp4', 'quicktime', 'h.264', 'divx', 'vdo', 'mov', 'mp3', 'wav', 'wma', 'mpeg', 'png', 'jpg', 'gif', 'jpeg', 'bmp'];
  public static ANSWER_MAX_LENGTH = 1000;

  public static DIALOG_WIDTH_85: string = "85rem";
  public static DIALOG_WIDTH_50: string = "50rem";
}


